/**
 * Utility function to set document title dynamically
 * Ensures consistent app naming across all pages
 */

import { NURSE_APP_TITLE } from '../constants/appConfig';

export const setDocumentTitle = (pageTitle = '', isNurseApp = false) => {
  const appName = isNurseApp ? 'ติวหมอไทย' : 'CannaTrade';
  const baseTitle = isNurseApp ? 'แอปติวสอบใบประกอบวิชาชีพแพทย์แผนไทย' : 'ตลาดซื้อขายกัญชาคุณภาพ';
  
  // สำหรับ ติวหมอไทย ให้ใช้ title เดียวกันจาก constant เพื่อ SEO
  if (isNurseApp) {
    // ใช้ title เดียวกันจากไฟล์กลาง (appConfig.js) เพื่อ SEO
    document.title = NURSE_APP_TITLE;
    return;
  }
  
  // สำหรับ CannaTrade routes ให้เปลี่ยน title ตามปกติ
  if (pageTitle) {
    document.title = `${pageTitle} - ${appName}`;
  } else {
    document.title = `${appName} - ${baseTitle}`;
  }
};

export const getDocumentTitle = () => {
  return document.title;
};













